module.exports = __webpack_public_path__ + "static/media/output_l.746cc60e.png";